import { createAction, props } from "@ngrx/store";
import { UserInformation } from "../user-typing";

export const loginUser = createAction("[USER] Logging in User");
export const loginUserSuccess = createAction("[USER] Logging in succeded", props<{ userInfo: UserInformation }>());
export const loginUserFailed = createAction("[USER] Logging in failed");
export const loginUserRepeat = createAction("[USER] Already logged in");

export const changeCurrentSite = createAction("[USER] Changing Current Site Started", props<{ newSiteId: string }>());
export const changeCurrentSiteSuccess = createAction(
	"[USER] Changing Current Site Succeeded",
	props<{ newSiteId: string }>(),
);
